"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndCallIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const EndCallIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "14", height: "13", viewBox: "0 0 14 13", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.53082 7.03477C4.79481 6.86978 4.76181 6.80378 4.79481 6.63879V5.18686C6.18074 4.72489 7.73166 4.75789 9.15058 5.18686L9.15058 6.63879C9.15058 6.83678 9.24812 6.86978 9.41457 7.03477L10.6694 8.09456C10.7608 8.22271 11.1965 8.22271 11.3945 8.02472L12.5494 6.86978C12.7474 6.67179 12.7474 6.4078 12.5494 6.20981C9.44757 3.10797 4.43183 3.10797 1.32998 6.20981C1.13199 6.4078 1.13199 6.67179 1.32998 6.86978L2.48493 8.02472C2.68292 8.22271 3.02031 8.17338 3.14489 8.02472C3.14489 8.02472 4.49369 7.05798 4.53082 7.03477Z", fill: color !== null && color !== void 0 ? color : theme.colors.white, stroke: color !== null && color !== void 0 ? color : theme.colors.white, strokeWidth: "0.5" }) })));
};
exports.EndCallIcon = EndCallIcon;
//# sourceMappingURL=end_call_icon.js.map